import React, { lazy, Suspense } from 'react';
import { useIsMounted } from '@wix/da-shared-react/pkg/utils/hooks/useIsMounted';
import { Props } from './DateNavigationRow';

import s from './DateNavigationRow.scss';

const DateControls = lazy(() =>
  import(
    /* webpackChunkName: "datepicker" */
    './DateControls'
  )
);

export const DateControlsLoadable: React.FC<Props> = props => {
  const isMounted = useIsMounted();

  const Loader = <div className={s['controls-container']} />;

  if (!isMounted) {
    return Loader;
  }

  return (
    <Suspense fallback={Loader}>
      <DateControls {...props} />
    </Suspense>
  );
};
DateControlsLoadable.displayName = 'DateControlsLoadable';

export default DateControlsLoadable;
